/* @ngInject */
function assetPackService ($q, ConnectorWebService, Utils, CONSTANTS) {
  let deferrable
  let assetPackSummaryData
  let loadingAssetPackSummaryData
  let lastAssetPackId
  let enableDownloadAllButtonListener = () => {}

  const service = {
    getAssetPackSummaryData,
    downloadAssetFoldersAndAssetsBatch,
    addEnableDownloadAllButtonListener,
    callEnableDownloadAllButtonListener,
    clearEnableDownloadAllButtonListener
  }
  return service

  /**
   * Gets asset pack summary data.
   *
   * @param {number} assetPackId
   * @returns {Promise}
   */
  async function getAssetPackSummaryData (assetPackId) {
    if (lastAssetPackId && lastAssetPackId.toString() === assetPackId.toString()) {
      if (loadingAssetPackSummaryData) {
        return deferrable.promise
      } else if (assetPackSummaryData) {
        return assetPackSummaryData
      }
    } else {
      lastAssetPackId = assetPackId
    }

    deferrable = $q.defer()
    loadingAssetPackSummaryData = true

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_SUMMARY, [assetPackId])
    ConnectorWebService.get(url).then((data) => {
      assetPackSummaryData = data
      deferrable.resolve(assetPackSummaryData)
      loadingAssetPackSummaryData = false
    }).catch((error) => {
      deferrable.reject(error)
    })

    return deferrable.promise
  }

  /**
   * Register the listener.
   *
   * @param {Function} callback
   */
  function addEnableDownloadAllButtonListener (callback) {
    enableDownloadAllButtonListener = callback
  }

  /**
   * Call the listener.
   *
   * @param {boolean} param indicates whether the button should be enabled
   */
  function callEnableDownloadAllButtonListener (enable) {
    enableDownloadAllButtonListener(enable)
  }

  /**
   * Clear the listener.
   *
   * @param {boolean} param indicates whether the button should be enabled
   */
  function clearEnableDownloadAllButtonListener () {
    enableDownloadAllButtonListener = () => {}
  }

  /**
   * Download selected asset folders and assets from an asset pack.
   *
   * @param {Object} params
   * @param {number} params.assetPackId
   * @param {number[]} [params.assetFolderIds]
   * @param {number[]} [params.assetIds]
   * @returns {Promise}
   */
  function downloadAssetFoldersAndAssetsBatch ({ assetPackId, assetFolderIds = [], assetIds = [] }) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_ASSET_PACK_DOWNLOAD_SELECTED_ASSETS_AND_FOLDERS, [assetPackId])
    if (assetFolderIds?.length) url = Utils.addQueryStringFromArray(url, 'assetFolderIds', assetFolderIds)
    if (assetIds?.length) url = Utils.addQueryStringFromArray(url, 'assetIds', assetIds)

    return Utils.downloadFile(url)
  }
}

export { assetPackService }
